import { Layout } from '../layout/Layout';
import { SomethingWentWrongHero } from './SomethingWentWrongHero';

export const SomethingWentWrongPage = () => (
  <Layout>
    <SomethingWentWrongHero />
  </Layout>
);
